import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { getCookie, setCookie } from 'cookies-next'

export default function useBdVid() {
  const router = useRouter()

  // 区分百度流量
  const { bd_vid, plan, unit, keyword, qhclickid, gclid, fbclid, wechat } = router.query

  useEffect(() => {
    if (bd_vid) {
      setCookie('bd_vid', bd_vid, {
        path: '/'
      })
    }

    if (plan) {
      setCookie('plan', plan, {
        path: '/'
      })
    }

    if (unit) {
      setCookie('unit', unit, {
        path: '/'
      })
    }

    if (keyword) {
      setCookie('keyword', keyword, {
        path: '/'
      })
    }

    if (qhclickid) {
      setCookie('qhclickid', qhclickid, {
        path: '/'
      })
    }

    if (gclid) {
      setCookie('gclid', gclid, {
        path: '/'
      })
    }

    if (fbclid) {
      setCookie('fbclid', fbclid, {
        path: '/'
      })
    }

    if (wechat) {
      setCookie('wechat', wechat, {
        path: '/'
      })
    }
  }, [bd_vid, plan, unit, keyword, qhclickid, gclid, fbclid, wechat])
}

export const getBdVid = () => {
  return {
    bd_vid: (getCookie('bd_vid') ?? '') as string,
    plan: (getCookie('plan') ?? '') as string,
    unit: (getCookie('unit') ?? '') as string,
    keyword: (getCookie('keyword') ?? '') as string,
    qhclickid: (getCookie('qhclickid') ?? '') as string,
    gclid: (getCookie('gclid') ?? '') as string,
    fbclid: (getCookie('fbclid') ?? '') as string,
    wechat: (getCookie('wechat') ?? '') as string
  }
}

export const getPromotionInfo = () => {
  const { bd_vid, plan, unit, keyword, qhclickid, gclid, fbclid, wechat } = getBdVid()
  const promotion_type = bd_vid
    ? 'baidu'
    : gclid
    ? 'google'
    : qhclickid
    ? '360'
    : fbclid
    ? 'facebook'
    : wechat
    ? 'wechat'
    : ''
  const promotion_id = bd_vid || gclid || qhclickid || fbclid || wechat || ''

  return {
    promotion_type,
    promotion_id,
    plan,
    unit,
    keyword
  }
}
